module.exports = __webpack_public_path__ + "img/services-image.8dc1882.webp";